import { EventEmitter, Injectable } from '@angular/core';
import { ZapResponse } from '../models/responses/zap-response';
import { CalComIntegrationResponse } from '../models/responses/calcom-integration-response';
import { CallLogResponse } from '../models/responses/call-log-response';
import { TelegramIntegrationResponse } from '../models/responses/telegram-integration-response';
import { PhoneSettingsResponse } from '../models/responses/phone-settings-response';
import { NotificationResponse } from '../models/responses/notification-response';
import { SmsSettingsResponse } from '../models/responses/sms-settings-response';
import { CallBackSettingsResponse } from '../models/responses/call-back-settings-response';
import { AutoCallBackSettingsResponse } from '../models/responses/auto-call-back-settings-response';
import { GoogleSheetsIntegrationResponse } from '../models/responses/google-sheets-integration-response';
import { MakeResponse } from '../models/responses/make-response';

@Injectable({
  providedIn: 'root'
})
export class AiConfigurationPageEventsService {
  onCreateNewAssistantEvent: EventEmitter<any> = new EventEmitter<any>();
  onEditAssistantEvent: EventEmitter<any> = new EventEmitter<any>();
  onZappierIntegrationAddedEvent: EventEmitter<ZapResponse> = new EventEmitter<ZapResponse>();
  onGoogleSheetAddedEvent: EventEmitter<GoogleSheetsIntegrationResponse> = new EventEmitter<GoogleSheetsIntegrationResponse>();
  onMakeIntegrationAddedEvent: EventEmitter<MakeResponse> = new EventEmitter<MakeResponse>();
  onSmsSettingsAddedEvent: EventEmitter<SmsSettingsResponse> = new EventEmitter<SmsSettingsResponse>();
  onMissedCallBackActionsSettingsAddedEvent: EventEmitter<AutoCallBackSettingsResponse> = new EventEmitter<AutoCallBackSettingsResponse>();
  onCallBackSettingsAddedEvent: EventEmitter<CallBackSettingsResponse> = new EventEmitter<CallBackSettingsResponse>();
  onNotificationIntegrationAddedEvent: EventEmitter<NotificationResponse> = new EventEmitter<NotificationResponse>();
  onCalIntegrationAddedEvent: EventEmitter<CalComIntegrationResponse> = new EventEmitter<CalComIntegrationResponse>();
  onTelegramIntegrationAddedEvent:EventEmitter<TelegramIntegrationResponse> = new EventEmitter<TelegramIntegrationResponse>();
  onRefreshAiAgentEvent: EventEmitter<any> = new EventEmitter<any>();
  onCallLogViewClickedEvent: EventEmitter<CallLogResponse> = new EventEmitter<CallLogResponse>();
  onCallLogBackClickedEvent: EventEmitter<any> = new EventEmitter<any>();
  onCampaignCallLogViewClickedEvent: EventEmitter<CallLogResponse> = new EventEmitter<CallLogResponse>();
  onCallLogViewBackedClickedEvent: EventEmitter<any> = new EventEmitter<any>();
  onCallLogViewDeletedEvent: EventEmitter<CallLogResponse> = new EventEmitter<CallLogResponse>();
  onTabToRenderEvent: EventEmitter<number> = new EventEmitter<number>();
  onSelectPhoneNumberEvent: EventEmitter<PhoneSettingsResponse> = new EventEmitter<PhoneSettingsResponse>();
}
